import { INNER_LOADER } from '../actionTypes';

export const Loading = (loading) => dispatch => {
    dispatch({
        type: INNER_LOADER,
        loading
    })
}